import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">编辑精选优质耽美漫画，每周更新不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {carouselItems.map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:scale-[1.01] transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.subtitle}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs px-3 py-1 rounded-full font-medium">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-heading text-lg md:text-xl text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-500 font-medium">· {item.subtitle}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-user-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span>{item.author}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}